module.exports = __webpack_public_path__ + "static/media/otherServices.36e22808.svg";